/**
 * A server timing metric that has its value set to the duration field
 */
export var TYPE_DURATION = "r";
/**
 * A server timing metric that has its value set to the description field
 */
export var TYPE_DESCRIPTION = "s";
/**
 * When a description metric has no value, we consider it to be a boolean and set it to this value.
 */
var BOOLEAN_TRUE_VALUE = "true";
export function getKeyValuePairs(config, serverTiming) {
    var pairs = {};
    serverTiming.forEach(function (stEntry) {
        var name = stEntry.name;
        var description = stEntry.description;
        if (name in config) {
            var spec = config[name];
            var multiplier = spec[1];
            if (spec[0] === TYPE_DURATION) {
                pairs[name] = stEntry.duration * (multiplier || 1);
            }
            else if (description && multiplier) {
                var numericValue = parseFloat(description);
                if (!isNaN(numericValue)) {
                    pairs[name] = numericValue * multiplier;
                }
            }
            else {
                pairs[name] = description || BOOLEAN_TRUE_VALUE;
            }
        }
    });
    return pairs;
}
